import React, { Component } from 'react';
import PlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete';
import { getLocation } from "../../store/action/location";
import {isAuthenticated, signOut} from "../../store/action/auth";
import ReactInterval from "react-interval";

const { user, token } = isAuthenticated();

class InputLocation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      coordinate: {},
      locations: [],
      loading:false,
      editMap:false,
      editGeo:false
    };
  }

  handleGeoChange = address => {
      this.props.onLocationChange(address)
  };

  handleMapChange = async e => {
    this.setState({
      address: e.target.value,
      loading: true
    });
  };

  getLocationSuggestions = async () => {
    const res = await getLocation(user._id, token, this.state.address);
    if (res.success) {
      this.setState({
        locations: res.locations
      })
    } else {
      console.log("Failed to find maps")
    }
    this.setState({loading:false})
  };

  handleGeoSelect = async (address,placeId) => {
      try {
          let geocode = await geocodeByPlaceId(placeId);
          let latLng = await getLatLng(geocode[0]);
          let coordinate = {
              latitude:latLng.lat,
              longitude:latLng.lng
          };

          const resPostal = geocode[0].address_components.filter(i => i.types[0] === 'postal_code');
          const postalCode = resPostal.length === 0 ? '-' : resPostal[0].long_name;
          this.setState({
              address,
              coordinate
          });
          this.props.setLocation(address, coordinate, placeId,postalCode);

      } catch (e) {
          console.log (e);
      }
  };

  handleMapSelect = i => {
      this.props.setMapLocation(i);
      this.setState({
          address: `${i.subdistrictName+", "+i.districtName+", "+ i.cityName+", "+i.provinceName+". "+i.postalCode}`,
          locations:[]
      })
  };

  render() {
    if (this.props.type === 'long') {
      return (
          <div>
            <ReactInterval
                timeout={1200}
                enabled={this.state.loading}
                callback={() => this.getLocationSuggestions()}
            />
            <input
                type="text"
                className="form-control"
                placeholder={this.props.placeholder}
                onChange={this.handleMapChange}
                value={this.state.address}
                required
            />

            <div className="location-suggestions-wrapper">
            {
              !this.state.locations ? "" :
              this.state.locations.map((i,idx) => (
                  <div key={idx} className="location-suggestions col-12">
                      <a onClick={() => this.handleMapSelect(i)}>
                          {i.subdistrictName+", "+i.districtName+", "+ i.cityName+", "+i.provinceName+". "+i.postalCode}
                      </a>
                  </div>


              ))
            }
            {
              this.state.loading ? <div>Loading...</div> : ""
            }
            </div>
          </div>
      )
    } else {
        const searchOptions = {
            componentRestrictions: { country: ['id'] }
        };

      return (
          <PlacesAutocomplete
              searchOptions={searchOptions}
              value={this.props.value}
              onChange={this.handleGeoChange}
              onSelect={this.handleGeoSelect}
              debounce={750}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className="form-group mb-0 input-group-sm">
                  <input
                      {...getInputProps({
                        placeholder: this.props.placeholder,
                        className: `${this.props.loading ? 'text-muted' :''} location-search-input form-control`,
                      })}
                      value={this.props.loading ?
                           this.props.loadingText ? this.props.loadingText : "Loading..."
                          : this.props.value
                      }
                      required
                  />
                  <div
                      className="autocomplete-dropdown-container"
                      style={{position:'absolute', zIndex:99 }}>
                    {
                        loading && <div className="bg-white border px-4">Loading...</div>
                    }
                    {
                        suggestions.map(suggestion => {
                          const className = suggestion.active
                              ? 'suggestion-item--active'
                              : 'suggestion-item';
                          // inline style for demonstration purpose
                          const style = suggestion.active
                              ? { backgroundColor: '#fafafa', cursor: 'pointer', zIndex:99  }
                              : { backgroundColor: '#ffffff', cursor: 'pointer', zIndex:99  };
                          return (
                              <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style
                                  })}
                                  className="px-4 pb-1 suggestion-item"
                              >
                                <span>
                                  <b>{suggestion.formattedSuggestion.mainText}</b>
                                </span>
                                <br/>
                                <span>{suggestion.formattedSuggestion.secondaryText}</span>
                              </div>
                          );
                        })
                    }
                  </div>
                </div>
            )}
          </PlacesAutocomplete>
      );
    }

  }
}

export default InputLocation;
